// Lib
import React from 'react';
import { Building2, UserRound } from 'lucide-react';

// Components
import { SelectableCard } from './SelectableCard';
import { cn } from '@components/lib/utils';

type RoleType = 'brand' | 'creator' | '';

interface RoleSelectorProps {
  selectedRole: RoleType;
  setSelectedRole: React.Dispatch<React.SetStateAction<RoleType>>;
}

interface RoleOption {
  value: Exclude<RoleType, ''>;
  title: string;
  description: string;
  Icon: typeof Building2;
}

const ROLE_OPTIONS: RoleOption[] = [
  {
    value: 'brand',
    title: 'Brand',
    description:
      'For a company or product promoted on behalf of a brand rather than an individual.',
    Icon: Building2,
  },
  {
    value: 'creator',
    title: 'Influencer',
    description:
      'For a personal brand — bloggers, content authors and experts in their niche.',
    Icon: UserRound,
  },
];

export const RoleSelector: React.FC<RoleSelectorProps> = ({
  selectedRole,
  setSelectedRole,
}) => (
  <div className="grid grid-cols-2 gap-3">
    {ROLE_OPTIONS.map(({ value, title, description, Icon }) => {
      const active = selectedRole === value;
      return (
        <SelectableCard
          key={value}
          active={active}
          onClick={() => setSelectedRole(value)}
          className="flex-col items-start gap-4 p-5"
        >
          <div
            className={cn(
              'flex size-12 items-center justify-center rounded-xl',
              active ? 'bg-marble-blue-100' : 'bg-marble-bg-50',
            )}
          >
            <Icon className="size-6 text-marble-blue-500" />
          </div>
          <div className="flex flex-col gap-1">
            <h2 className="text-base font-bold text-foreground">{title}</h2>
            <p className="text-sm text-muted-foreground">{description}</p>
          </div>
        </SelectableCard>
      );
    })}
  </div>
);
